<template>
    <Card is-round mode="default" is-dark class="uk-card-hover">
        <div class="uk-text-center">
            <div class="uk-inline">
                <img
                    v-if="clickAndBuy.mediaFileId"
                    :src="
                        apiUrl +
                        '/clickandbuys/' +
                        clickAndBuy.id +
                        '/media/' +
                        clickAndBuy.mediaFileId
                    "
                    class="clickandbuy-media"
                    :alt="clickAndBuy.mediaFileId" />
                <div
                    v-if="clickAndBuy.fundraising?.isGoalReached"
                    class="uk-position-cover uk-overlay-primary border-radius-next uk-flex uk-flex-center uk-flex-middle">
                    <Translate
                        class="goal-reached-text"
                        :translation-key="getCampaignGoalReachedText" />
                </div>
            </div>
        </div>

        <div
            v-if="!clickAndBuy.fundraising?.isGoalReached"
            class="clickandbuy-price uk-badge badge lunacart-theme-color lunacart-theme-background">
            {{ getPrice() }}
        </div>

        <div class="clickandbuy-title">
            {{ clickAndBuy.title }}
        </div>

        <div
            v-if="clickAndBuy.text"
            class="clickandbuy-text"
            v-html="
                clickAndBuy.text.length > 440
                    ? clickAndBuy.text.slice(0, 437) + '...'
                    : clickAndBuy.text
            " />

        <div v-if="!clickAndBuy.fundraising?.isGoalReached">
            <div class="uk-margin-top" />
            <div v-if="clickAndBuy.variants && clickAndBuy.variants.length > 0">
                <Translate class="variant-name" translation-key="options" />
                <div class="uk-margin-xsmall-top" />
                <div v-for="variant in clickAndBuy.variants" :key="variant.id">
                    <span
                        class="variant-option uk-margin-xsmall-right"
                        v-for="option in variant.options"
                        :key="variant.id + option.name">
                        <span class="uk-badge uk-badge-default">{{
                            option.name
                        }}</span>
                    </span>
                </div>
            </div>
        </div>

        <div class="uk-margin-medium-top" />
        <span v-on:click="selected()">
            <LinkObject
                :to="
                    computedGetClickAndBuyRootLink +
                    '/' +
                    clickAndBuy.id +
                    computedGetClickAndBuyQueryParam
                ">
                <Button
                    with-class="lunacart-theme-background lunacart-theme-background-hover lunacart-theme-color"
                    mode="primary"
                    is-round
                    is-max
                    is-large>
                    <Translate :translation-key="getToMessage" />
                </Button>
            </LinkObject>
        </span>
    </Card>
</template>

<script>
import Card from '@/components/generic/Card.vue';
import Button from '@/components/generic/Button.vue';
import Translate from '@/components/Translate.vue';
import LinkObject from '@/components/LinkObject.vue';

export default {
    name: 'ClickAndBuyElement',
    components: {LinkObject, Translate, Button, Card},
    props: {
        clickAndBuy: {
            id: String,
            title: String,
            text: String,
            mediaFileId: String,
            price: Number,
        },
    },
    methods: {
        selected() {
            this.$store.state.clickandbuyfollow = true;
        },
        getPrice() {
            if (this.clickAndBuy.price && this.clickAndBuy.price > 0.0) {
                return this.getNumberWithCurrency(this.clickAndBuy.price);
            }

            return this.$t('free');
        },
    },
    computed: {
        getCampaignGoalReachedText() {
            if (this.clickAndBuy?.fundraising?.type === 'donation') {
                return 'donate.goal.reached';
            }

            if (this.clickAndBuy?.fundraising?.type === 'sponsoring') {
                return 'sponsor.goal.reached';
            }

            return 'campaign.goal.reached';
        },
        getToMessage() {
            if (this.clickAndBuy.fundraising?.type === 'donation') {
                return 'donation.to';
            }

            if (this.clickAndBuy.fundraising?.type === 'sponsoring') {
                return 'sponsoring.to';
            }

            if (this.isWithPriceVariable) {
                return 'more.information';
            }

            if (this.isWithPrice) {
                return 'to.offer';
            }

            return 'Select';
        },
        isWithPriceVariable() {
            return (
                this.clickAndBuy &&
                this.clickAndBuy.isPriceVariable &&
                this.clickAndBuy.isPriceVariable > 0.0
            );
        },
        isWithPrice() {
            return (
                this.clickAndBuy &&
                this.clickAndBuy.price &&
                this.clickAndBuy.price > 0.0
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.goal-reached-text {
    color: #fff;
    font-weight: 500;
    font-size: 22px;
}

.goal-reached-struct {
    border-radius: $border-radius-next;
}

.clickandbuy-media {
    border-radius: $border-radius-next;
    max-height: 200px;
}

.clickandbuy-title {
    font-size: 18px;
    font-weight: 500;
    margin-top: 20px;
}

.clickandbuy-text {
    word-break: break-word;
    margin-top: 15px;
    font-weight: 100;
}

.clickandbuy-price {
    margin-top: 20px;
}

.badge {
    font-size: 16px !important;
    padding: 12px 15px !important;
    background-color: $info-color !important;
}

.variant-name {
    font-size: 14px;
    font-weight: 500;
}

.variant-option {
    font-size: 14px;
}
</style>
